// Route-specific acquisition metadata and authentication indexing policy.
export const defaultMetadata = {
  "title": "Team Bridge - Games For Remote Team Socials",
  "description": "Virtual team building games to play remotely. Choose from a collection of games and activities to play for free!"
};
export const pageMetadata = {
  '/blog/choices-with-introductions': {
    canonical: 'https://teambridge.app/blog/choices-with-introductions',
    title: 'Choices with Introductions: A Printable Team Activity | TeamBridge',
    description: 'A printable 10–15 minute introduction activity for adult colleagues, with everyday choices, voluntary participation and a step-by-step facilitator guide.'
  },
  '/blog/virtual-holiday-party-agenda': {
    canonical: 'https://teambridge.app/blog/virtual-holiday-party-agenda',
    title: 'A 45-Minute Virtual Holiday Party Agenda | TeamBridge',
    description: 'Host a relaxed year-end team gathering with a 45-minute agenda, drawing or word games, ready-to-use host prompts and a no-game backup plan.'
  },
  '/account-help': {
    canonical: 'https://teambridge.app/account-help',
    title: 'Sign-in and Team Manager Help | TeamBridge',
    description: 'Help with TeamBridge sign-in, password recovery and owner-controlled team manager access.'
  },
  '/blog/remote-team-halloween-games': {
    canonical: 'https://teambridge.app/blog/remote-team-halloween-games',
    title: 'Remote Team Halloween Games: A Relaxed 30-Minute Plan | TeamBridge',
    description: 'Plan an optional remote team Halloween social with drawing deduction or word games, a flexible agenda, and a practical host and joining checklist.'
  },
  '/plan': {
    canonical: 'https://teambridge.app/plan',
    title: 'Team Event Planner: Plan a Fun Team Event in 2 Minutes | TeamBridge',
    description: 'Pick your team size, time and vibe and get a ready-made lineup of browser games with one-click start links. For 3 to 200 people on Zoom, Teams or Meet.'
  },
  '/pricing': {
    title: defaultMetadata.title,
    description: defaultMetadata.description,
    canonical: 'https://www.teambridge.app/pricing'
  },
  "/team-game-cost-calculator": {
    "canonical": "https://teambridge.app/team-game-cost-calculator",
    "title": "Team Game Cost Calculator | TeamBridge",
    "description": "Compare TeamBridge costs for your team size and how often you play: total cost, players covered and terms."
  },
  "/employee-appreciation-week-games": {
    "canonical": "https://teambridge.app/employee-appreciation-week-games",
    "title": "Employee Appreciation Week Games: A Five-Day Plan | TeamBridge",
    "description": "Plan five optional remote team game sessions with setup steps, player ranges, free-credit limits and a premium-game alternative."
  },
  "/blog/weekly-team-game-rotation": {
    "canonical": "https://teambridge.app/blog/weekly-team-game-rotation",
    "title": "A Four-Week Team Game Rotation for Remote Teams | TeamBridge",
    "description": "Plan four optional team sessions: word prompts, drawing deduction, trivia and a low-pressure icebreaker, with player limits, access checks and host prep."
  },
  "/blog/online-team-games-for-10-people": {
    "canonical": "https://teambridge.app/blog/online-team-games-for-10-people",
    "title": "Online Team Games for 10 People: A Practical Guide | TeamBridge",
    "description": "Choose a game for ten coworkers: word prompts, drawing deduction or two teams of five. Get setup steps, player limits and a realistic meeting plan."
  },
  "/blog/virtual-icebreaker-games": {
    "title": "Virtual Icebreaker Games",
    "description": "Virtual icebreaker games to play with your teams online"
  },
  "/game/starts-with-j": {
    "title": "How to Play Starts With J Virtually",
    "description": "Learn how to play Starts With J virtually with your team."
  },
  "/game/scribble": {
    "title": "How to Play Scribble Virtually",
    "description": "Learn how to play Scribble virtually with your team."
  },
  "/game/cosel": {
    "title": "How to Play Cosel Virtually",
    "description": "Learn how to play Cosel virtually with your team."
  },
  "/blog/online-team-games-for-4-people": {
    "canonical": "https://teambridge.app/blog/online-team-games-for-4-people",
    "title": "Online Team Games for 4 People: A Host’s Guide | TeamBridge",
    "description": "Choose a browser game for four coworkers: compare word prompts and drawing deduction, check player requirements, and plan a relaxed remote session."
  },
  "/blog/15-minute-team-trivia": {
    "canonical": "https://teambridge.app/blog/15-minute-team-trivia",
    "title": "How to Run a 15-Minute Team Trivia Break | TeamBridge",
    "description": "Host a short remote-team trivia break with a practical 15-minute agenda, verified game settings, joining checklist and inclusive facilitation tips."
  },
  "/blog/15-minute-online-drawing-game": {
    canonical: 'https://teambridge.app/blog/15-minute-online-drawing-game',
    "title": "A 15-Minute Online Drawing Game for Small Teams | TeamBridge",
    "description": "Plan a short Scribble session for 3–6 coworkers: a 15-minute agenda, drawing settings, host checklist and simple rules for your next video call."
  },
  "/blog/online-team-game-20-people": {
    canonical: 'https://teambridge.app/blog/online-team-game-20-people',
    "title": "An Online Team Game for 20 People: A Host’s Guide | TeamBridge",
    "description": "Run Starts With J with 20 remote colleagues. A practical guide to lobby setup, game settings, answering, voting and planning your video-call session."
  },
  "/game/fake-artist": {
    "title": "How to Play Fake Artist Virtually",
    "description": "Learn how to play Fake Artist virtually with your team."
  },
  "/game/taboo": {
    "title": "How to Play Taboo Virtually",
    "description": "Learn how to play Taboo virtually with your team."
  },
  "/game/codenames": {
    "title": "How to Play Codenames Virtually",
    "description": "Learn how to play Codenames virtually with your team."
  },
  "/game/two-truths-one-lie": {
    "title": "How to Play Two Truths, One Lie Virtually",
    "description": "Learn how to play Two Truths, One Lie virtually with your team."
  },
  "/game/draw-battle": {
    "title": "How to Play Draw Battle Virtually",
    "description": "Learn how to play Draw Battle virtually with your team."
  },
  // Pages that had no canonical in their first HTML (traffic research 2026-10-23); the app renders the same
  // tags (src/components/PageMetadataHelmet.js) so they survive hydration.
  '/about': {
    canonical: 'https://teambridge.app/about',
    title: 'About TeamBridge: Team Games for Remote and Hybrid Teams',
    description: 'TeamBridge makes browser games for team meetings, socials and all-hands. Share one link in Zoom, Teams or Meet and everyone plays together.'
  },
  '/contact': {
    canonical: 'https://teambridge.app/contact',
    title: 'Contact TeamBridge',
    description: 'Questions about TeamBridge games, passes or your team event? Send us a message and we will get back to you.'
  },
  '/blog/virtual-icebreaker-games': {
    canonical: 'https://teambridge.app/blog/virtual-icebreaker-games',
    title: 'Virtual Icebreaker Games for Remote Teams | TeamBridge',
    description: 'Virtual icebreaker games to play with your team online: Faker, This or That and Two Truths, One Lie, each ready to start from a lobby link.'
  },
  "/blog/team-drawing-games": {
    canonical: 'https://www.teambridge.app/blog/team-drawing-games',
    "title": "Team Drawing Games to Play Online | TeamBridge",
    "description": "Team drawing games to play online with coworkers: Scribble (draw and guess) and Cosel (drawing telephone) in the browser. Free to start in Zoom, Teams or Meet."
  }
};

// Social cards are limited to these public game pages; never include lobby data.
const socialImages = {
  '/game/fake-artist': ['fakeArtist.png', 'Fake Artist game artwork'],
  '/game/codenames': ['codenames.png', 'Codenames game artwork'],
  '/game/taboo': ['taboo.png', 'Taboo game artwork']
};
export function getSocialMetadata(pathname) {
  const image = socialImages[pathname];
  if (!image) return {};
  const metadata = pageMetadata[pathname];
  return {
    'og:title': metadata.title,
    'og:description': metadata.description,
    'og:url': `https://www.teambridge.app${pathname}`,
    'og:image': `https://www.teambridge.app/social/${image[0]}`,
    'og:type': 'website',
    'og:image:alt': image[1]
  };
}
export const escapeHtml = value => value.replace(/[&<>"']/g, char => ({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
})[char]);
export const isLoginPath = pathname => /^\/login\/?$/.test(pathname);
export function renderPageMetadata(html, pathname) {
  if (isLoginPath(pathname)) {
    return html.replace(/<\/head>/i, '<meta data-react-helmet="true" name="robots" content="noindex,follow"></head>');
  }
  const metadata = pageMetadata[pathname];
  if (!metadata) return html;
  const socialTags = Object.entries(getSocialMetadata(pathname)).map(([property, content]) => `<meta data-react-helmet="true" property="${property}" content="${escapeHtml(content)}">`).join('');
  const rendered = html.replace(/<\/head>/i, () => `${socialTags}</head>`).replace(/<title[^>]*>[\s\S]*?<\/title>/i, () => `<title>${escapeHtml(metadata.title)}</title>`).replace(/<meta\b[^>]*name=["']description["'][^>]*>/i, () => `<meta data-react-helmet="true" name="description" content="${escapeHtml(metadata.description)}">`);
  return metadata.canonical ? rendered.replace(/<\/head>/i, `<link data-react-helmet="true" rel="canonical" href="${escapeHtml(metadata.canonical)}"></head>`) : rendered;
}